import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App'; // Commentez ou supprimez la ligne de l'App
import App from './App'; // Ajoutez l'import pour votre test
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
